import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  return (
    <div className="px-8 md:px-16 py-20 max-w-6xl mx-auto w-full">
      <div className="text-center mb-16">
        <h1 className="text-6xl text-olive mb-4">PONTE EN CONTACTO</h1>
        <p className="text-olive/80 max-w-xl mx-auto">We'd love to hear from you. Whether it's a reservation, a private event, or just to say hello.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-16 items-start">
        {/* Contact Info */}
        <div className="bg-sand-light p-10 border border-olive/10 shadow-sm rounded-tr-[50px] rounded-bl-[50px]">
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <SafeIcon name="MapPin" className="text-rust w-6 h-6" />
              <h3 className="text-2xl font-display text-olive">Location</h3>
            </div>
            <p className="text-olive/80 pl-9">123 Culinary Avenue<br/>Food District, FD 90210</p>
          </div>
          
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <SafeIcon name="Clock" className="text-rust w-6 h-6" />
              <h3 className="text-2xl font-display text-olive">Hours</h3>
            </div>
            <p className="text-olive/80 pl-9">Mon - Thu: 11am - 10pm<br/>Fri - Sun: 11am - 11pm</p>
          </div>
          
          <div>
            <div className="flex items-center gap-3 mb-2">
              <SafeIcon name="Phone" className="text-rust w-6 h-6" />
              <h3 className="text-2xl font-display text-olive">Contact</h3>
            </div>
            <p className="text-olive/80 pl-9">hola@lacasakitchen.demo<br/>(555) 123-4567</p>
          </div>

          <div className="mt-12 pt-8 border-t border-olive/20">
            <h4 className="font-display text-xl text-olive mb-4">Follow Us</h4>
            <div className="flex gap-4">
              <button className="w-10 h-10 rounded-full bg-olive text-sand flex items-center justify-center hover:bg-rust transition">
                <SafeIcon name="Instagram" className="w-5 h-5" />
              </button>
              <button className="w-10 h-10 rounded-full bg-olive text-sand flex items-center justify-center hover:bg-rust transition">
                <SafeIcon name="Facebook" className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div>
          <h3 className="text-3xl font-display text-olive mb-6">Send us a Message</h3>
          <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
            <div className="grid grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-semibold text-olive mb-2 uppercase tracking-wide">First Name</label>
                <input type="text" className="w-full bg-transparent border-b-2 border-olive/30 focus:border-rust outline-none py-2 transition-colors text-olive" placeholder="John" />
              </div>
              <div>
                <label className="block text-sm font-semibold text-olive mb-2 uppercase tracking-wide">Last Name</label>
                <input type="text" className="w-full bg-transparent border-b-2 border-olive/30 focus:border-rust outline-none py-2 transition-colors text-olive" placeholder="Doe" />
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-semibold text-olive mb-2 uppercase tracking-wide">Email Address</label>
              <input type="email" className="w-full bg-transparent border-b-2 border-olive/30 focus:border-rust outline-none py-2 transition-colors text-olive" placeholder="john@example.com" />
            </div>

            <div>
              <label className="block text-sm font-semibold text-olive mb-2 uppercase tracking-wide">Subject</label>
              <select className="w-full bg-transparent border-b-2 border-olive/30 focus:border-rust outline-none py-2 transition-colors text-olive">
                <option>General Inquiry</option>
                <option>Reservations</option>
                <option>Private Events</option>
                <option>Feedback</option>
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-semibold text-olive mb-2 uppercase tracking-wide">Message</label>
              <textarea rows="4" className="w-full bg-transparent border-b-2 border-olive/30 focus:border-rust outline-none py-2 transition-colors text-olive resize-none" placeholder="How can we help you?"></textarea>
            </div>

            <button type="submit" className="btn-primary w-full">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;